import type { DirectoryEntry } from "@estelle/domain";

import { formatMoney } from "@/components/table/cells";

/**
 * "3 orders · ₹4,120.00 · last 12 Oct" (#637): a customer's figures in one
 * line, for the phone card. Null for a contact, who has no orders.
 */
export function figuresLine(
  entry: Pick<
    DirectoryEntry,
    "kind" | "ordersCount" | "totalSpent" | "lastOrderAt"
  >,
): string | null {
  if (entry.kind !== "customer" || entry.ordersCount === null) return null;
  const parts = [
    `${String(entry.ordersCount)} order${entry.ordersCount === 1 ? "" : "s"}`,
    entry.totalSpent !== null && entry.ordersCount > 0
      ? formatMoney(entry.totalSpent)
      : null,
    entry.lastOrderAt
      ? `last ${new Date(entry.lastOrderAt).toLocaleDateString("en-IN", {
          day: "numeric",
          month: "short",
          timeZone: "Asia/Kolkata",
        })}`
      : null,
  ];
  return parts.filter(Boolean).join(" · ");
}
